import { FC } from 'react';
import styles from './About.module.scss';
import CustomButton from '../customButton';

const About: FC = () => {
  return (
    <section id="about" className={styles.container}>
      <div className={styles.row}>
        <h2 className={styles.header}>About Me</h2>

        <div className={styles['about-me']}>
          <p>
            Senior Product & Frontend Engineer with 10+ years building high-impact digital products, plus 3 years
            shipping SaaS independently from concept to production. My core specialty is React, TypeScript, and frontend
            architecture — that's where I lead and where I'm strongest.
          </p>

          <p>
            I'm comfortable with Node.js, AWS, and CI/CD when a project needs it, and I actively use AI tooling to build
            and ship faster — though my depth and focus stay in frontend.
          </p>

          <p>
            Working remotely in international, English-speaking teams, I've led frontend initiatives, built design
            systems, and shipped production UIs at scale. As an independent SaaS builder, I also operate with a product
            mindset — auth, payments, deployment, all handled solo when needed.
          </p>

          <ul className={styles.highlights}>
            <li>React, TypeScript and modern frontend architecture</li>
            <li>Design systems, performance and developer experience</li>
            <li>Independent SaaS builder — auth, payments, deployment, solo</li>
            <li>Comfortable with Node.js and full-stack when needed</li>
          </ul>

          <div className={styles.buttons}>
            <CustomButton title="My LinkedIn" href="https://www.linkedin.com/in/cerejo/" target="_blank" />
            <CustomButton title="Download my CV" href="/files/CV_JoseCerejo.pdf" download />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
